import {Avatar} from 'antd';
import {AvatarProps} from 'antd/es/avatar';
import {AccountFieldsFragment, MasterAccountFieldsFragment, Maybe} from 'api/generated';
import React from 'react';

type Props = {
  account?: Maybe<AccountFieldsFragment | MasterAccountFieldsFragment>;
};

// This function returns the favicon URL for the given account
export const getFaviconUrl = (
  account?: Maybe<AccountFieldsFragment | MasterAccountFieldsFragment>
) => {
  // Use optional chaining to access the properties of account
  const {branding, publicBusinessDetails, business} = account || {};

  if (branding?.iconUrl) return branding.iconUrl;

  const website = publicBusinessDetails?.website || business?.website;
  if (website) return `https://d1l5mg5ladb8cd.cloudfront.net/icon?url=${website}&size=16..32..64`;

  return undefined;
};

export const Favicon: React.FC<Props & AvatarProps> = ({account, ...props}) => {
  const iconUrl = getFaviconUrl(account);
  return <Avatar {...props} src={iconUrl} />;
};
